import { View } from './view'

export const GetLoanEasy = View
